import React from "react";
import EnhanceSearchBar from "theme/modules/Search/SearchBar/EnhanceSearchBar";
import Autocomplete from "theme/components/organisms/Autocomplete/Autocomplete";
import SearchBarQuery from "./SearchBarQuery.gql";
import SearchBarResults from "theme/modules/Search/SearchBar/SearchBarResults";
import useSearchBar from "theme/modules/Search/SearchBar/useSearchBar";
import SearchBarForm from "theme/modules/Search/SearchBar/SearchBarForm";

const SearchBar = ({
  search,
  setSearch,
  data,
  loading,
  error,
  onFocusRequest,
}) => {
  const {
    contentRef,
    searchBarRef,
    searchUrl,
    searchTarget,
    onSubmit,
    onChange,
    onFocus,
    showAutocompleteResults,
    isOpen,
    setIsOpen,
    selected,
    onSelect,
  } = useSearchBar({ search, setSearch, data, onFocusRequest });

  return (
    <div className="search-box" ref={contentRef}>
      <div className="search-box__form" ref={searchBarRef}>
        <SearchBarForm
          search={search}
          searchTarget={searchTarget}
          data={data}
          selected={selected}
          isExpanded={showAutocompleteResults}
          onSubmit={onSubmit}
          onChange={onChange}
          onFocus={onFocus}
        />
      </div>
      {isOpen && (
        <Autocomplete onClose={() => setIsOpen(false)}>
          <SearchBarResults
            loading={loading ?? true}
            error={error}
            search={search}
            searchUrl={searchUrl}
            results={data?.searchSuggestions}
            selected={selected}
            onSelect={onSelect}
            onQuerySelect={(query) => {
              setSearch({ search: query });
              onSelect(query);
            }}
          />
        </Autocomplete>
      )}
    </div>
  );
};

export default EnhanceSearchBar({
  SearchQuery: SearchBarQuery,
})(SearchBar);
